/*jshint esversion: 6 */
/*jshint sub:true*/
import axios from 'axios';
import {extractErrorDetails} from '@/helpers/util.js';

const initialState = () => ({
  wp_1: {},
  wp_2: {},
  error: ''
});

// State object
const state = initialState();
// Getter functions
const getters = {
  getWP1: (state) => state.wp_1,
  getWP2: (state) => state.wp_2,
  isLoading: (state) => state.loading
};
// Actions
const actions = {
  getTwoRandomWPs({commit}){
    axios({
      url: 'ai/workpackages',
      method: 'GET',
      headers: {
        'Cache-Control': 'no-cache'
      }
    })
    .then(resp => {
      commit('set_wps', resp.data.data);
    })
    .catch(err => {
      commit('set_error', extractErrorDetails(err));
    });
  },
  createCountryLabel({commit, state}, label){
    axios({
      url: 'ai/country-label',
      method: 'POST',
      data: {
        label: label,
        work_package: state.wp_1,
      }
    })
    .then(() => {
      axios({
        url: 'ai/workpackages',
        method: 'GET',
        headers: {
          'Cache-Control': 'no-cache'
        }
      })
      .then(resp => {
        commit('set_wps', resp.data.data);
      })
      .catch(err => {
        commit('set_error', extractErrorDetails(err));
      });
    })
    .catch(err => {
      commit('set_error', extractErrorDetails(err));
    });
  },
  createSimilarityLabel({commit, state}, label){
    axios({
      url: 'ai/similarity-label',
      method: 'POST',
      data: {
        label: label,
        work_package_a: state.wp_1,
        work_package_b: state.wp_2
      }
    })
    .then(() => {
      axios({
        url: 'ai/workpackages',
        method: 'GET',
        headers: {
          'Cache-Control': 'no-cache'
        }
      })
      .then(resp => {
        commit('set_wps', resp.data.data);
      })
      .catch(err => {
        commit('set_error', extractErrorDetails(err));
      });
    })
    .catch(err => {
      commit('set_error', extractErrorDetails(err));
    });
  },
  createOrderLabel({commit, state}, label){
    axios({
      url: 'ai/order-label',
      method: 'POST',
      data: {
        label: label,
        work_package_a: state.wp_1,
        work_package_b: state.wp_2
      }
    })
    .then(() => {
      axios({
        url: 'ai/workpackages',
        method: 'GET',
        headers: {
          'Cache-Control': 'no-cache'
        }
      })
      .then(resp => {
        commit('set_wps', resp.data.data);
      })
      .catch(err => {
        commit('set_error', extractErrorDetails(err));
      });
    })
    .catch(err => {
      commit('set_error', extractErrorDetails(err));
    });
  },
  createCompleteWorkPackageAI({commit}, work_package){
    axios({
      url: 'workpackages/completeworkpackage',
      method: 'POST',
      data: work_package
    })
    .then(() => {
        axios({
          url: 'ai/workpackages',
          method: 'GET',
          headers: {
            'Cache-Control': 'no-cache'
          }
        })
        .then(resp => {
          commit('set_wps', resp.data.data);
        })
        .catch(err => {
          commit('set_error', extractErrorDetails(err));
        });
      })
    .catch(err => {
      commit('set_error', extractErrorDetails(err));
    });
  },
  updateWorkStepAI({commit}, payload){
    commit('update_wp1_workstep', payload);
  },
  deleteWorkStepAI({commit}, index){
    commit('delete_wp1_workstep', index);
  },
  addWorkStepAI({commit}, text){
    commit('add_wp1_workstep', text);
  },
  pushWorkStepAI({commit}, event){
    commit('wp_1_push_ws_position', event);
  }
};
// Mutations
const mutations = {
  reset(state) {
    const newState = initialState();
    Object.keys(newState).forEach(key => {
      state[key] = newState[key];
    });
  },
  set_wps(state, wps){
    state.wp_1 = wps.work_package_1;
    state.wp_2 = wps.work_package_2;
  },
  set_error(state, err){
    state.error = err;
  },
  update_wp1_workstep(state, payload){
    state.wp_1.work_steps = [
      ...state.wp_1.work_steps.slice(0, payload.index),
      { text: payload.text, manpower: 0},
      ...state.wp_1.work_steps.slice(payload.index + 1)
    ];
  },
  delete_wp1_workstep(state, index){
    state.wp_1.work_steps = [
      ...state.wp_1.work_steps.slice(0, index),
      ...state.wp_1.work_steps.slice(index + 1)
    ];
  },
  add_wp1_workstep(state, text){
    state.wp_1.work_steps = [
      ...state.wp_1.work_steps,
      { text: text, manpower: 0}
    ];
  },
  wp_1_push_ws_position(state, event){
    // event.moved.oldIndex
    // event.moved.newIndex
    let twork_step = state.wp_1.work_steps[event.moved.oldIndex];
    if (event.moved.oldIndex < event.moved.newIndex) {
      state.wp_1.work_steps = [
        ...state.wp_1.work_steps.slice(0, event.moved.oldIndex),
        ...state.wp_1.work_steps.slice(event.moved.oldIndex + 1, event.moved.newIndex + 1),
        twork_step,
        ...state.wp_1.work_steps.slice(event.moved.newIndex + 1)
      ];
    } else {
      state.wp_1.work_steps = [
        ...state.wp_1.work_steps.slice(0, event.moved.newIndex),
        twork_step,
        ...state.wp_1.work_steps.slice(event.moved.newIndex, event.moved.oldIndex),
        ...state.wp_1.work_steps.slice(event.moved.oldIndex + 1)
      ];
    }
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
